import lazyLoad from '@utils/lazyLoad'

const couponRoutes = [
  // 系统优惠券
  {
    path: '/store/crm_coupon_list',
    exact: true,
    component: lazyLoad(() =>
      import('@views/Marketing/CouponMangement/Local/List')
    ),
    meta: {
      layoutMode: 'empty'
    }
  },
  // 系统优惠券详情
  {
    path: '/store/crm_coupon_list/detail/:brandId/:id',
    exact: true,
    component: lazyLoad(() =>
      import('@views/Marketing/CouponMangement/Local/Detail')
    ),
    meta: {
      applicationCode: 'fe215caa-efeb-4646-836a-92cd3904f3d7',
      title: '系统优惠券详情'
    }
  },
  // 添加系统优惠券
  {
    path: '/store/crm_coupon_list/create',
    exact: true,
    component: lazyLoad(() =>
      import('@views/Marketing/CouponMangement/Local/Create')
    ),
    meta: {
      applicationCode: 'fe215caa-efeb-4646-836a-92cd3904f3d7',
      title: '添加系统优惠券'
    }
  },
  // 添加系统优惠券
  {
    path: '/store/crm_coupon_list/edit/:id',
    exact: true,
    component: lazyLoad(() =>
      import('@views/Marketing/CouponMangement/Local/Create')
    ),
    meta: {
      applicationCode: 'fe215caa-efeb-4646-836a-92cd3904f3d7',
      title: '编辑系统优惠券'
    }
  }
  // // 编辑系统优惠券
  // {
  //   path: '/store/crm_coupon_list/:id/edit',
  //   exact: true,
  //   component: lazyLoad(() => import('@views/Marketing/Coupon/Create/Crm')),
  //   meta: {
  //     applicationCode: 'fe215caa-efeb-4646-836a-92cd3904f3d7',
  //     title: '编辑系统优惠券'
  //   }
  // },
  // // 微信优惠券
  // {
  //   path: '/store/coupon_list',
  //   exact: true,
  //   component: lazyLoad(() => import('@views/Marketing/Coupon/List/Wx'))
  // },
  // // 微信优惠券详情
  // {
  //   path: '/store/coupon_list/:id',
  //   exact: true,
  //   component: lazyLoad(() => import('@views/Marketing/Coupon/Detail')),
  //   meta: {
  //     applicationCode: 'fe215caa-efeb-4646-836a-92cd3904f3d7',
  //     title: '微信优惠券详情'
  //   }
  // },
  // // 微信支付代金券
  // {
  //   path: '/store/coupon_pay_list',
  //   exact: true,
  //   component: lazyLoad(() => import('@views/Marketing/Coupon/List/WxPay'))
  // },
  // // 支付宝支付代金券
  // {
  //   path: '/store/coupon_al_pay_list',
  //   exact: true,
  //   component: lazyLoad(() => import('@views/Marketing/Coupon/List/AliPay'))
  // },

  // // 微信支付优惠券详情
  // {
  //   path: '/store/coupon_pay_list/:id',
  //   exact: true,
  //   component: lazyLoad(() => import('@views/Marketing/Coupon/Detail')),
  //   meta: {
  //     applicationCode: 'fe215caa-efeb-4646-836a-92cd3904f3d7',
  //     title: '微信支付代金券详情'
  //   }
  // },
  // // 支付宝支付优惠券详情
  // {
  //   path: '/store/coupon_al_pay_list/:id',
  //   exact: true,
  //   component: lazyLoad(() => import('@views/Marketing/Coupon/Detail')),
  //   meta: {
  //     applicationCode: 'fe215caa-efeb-4646-836a-92cd3904f3d7',
  //     title: '支付宝优惠券详情'
  //   }
  // },
  // // 添加支付宝支付优惠券
  // {
  //   path: '/store/:type/create/aliPay',
  //   exact: true,
  //   component: lazyLoad(() => import('@views/Marketing/Coupon/Create/AliPay')),
  //   meta: {
  //     applicationCode: 'fe215caa-efeb-4646-836a-92cd3904f3d7',
  //     title: '添加支付宝支付优惠券'
  //   }
  // },
  // // 添加支付宝支付优惠券
  // {
  //   path: '/store/:type/edit/aliPay',
  //   exact: true,
  //   component: lazyLoad(() => import('@views/Marketing/Coupon/Create/AliPay')),
  //   meta: {
  //     applicationCode: 'fe215caa-efeb-4646-836a-92cd3904f3d7',
  //     title: '编辑支付宝支付优惠券'
  //   }
  // },
  // // 添加微信优惠券
  // {
  //   path: '/store/:type/create/wx',
  //   exact: true,
  //   component: lazyLoad(() => import('@views/Marketing/Coupon/Create/Wx')),
  //   meta: {
  //     applicationCode: 'fe215caa-efeb-4646-836a-92cd3904f3d7',
  //     title: '添加微信优惠券'
  //   }
  // },
  // // 编辑微信优惠券
  // {
  //   path: '/store/:type/edit/wx',
  //   exact: true,
  //   component: lazyLoad(() => import('@views/Marketing/Coupon/Create/Wx')),
  //   meta: {
  //     applicationCode: 'fe215caa-efeb-4646-836a-92cd3904f3d7',
  //     title: '编辑微信优惠券'
  //   }
  // },
  // // 微信支付优惠券编辑
  // {
  //   path: '/store/coupon_pay_list/edit/:id',
  //   exact: true,
  //   component: lazyLoad(() => import('@views/Marketing/Coupon/Edit/WxPay')),
  //   meta: {
  //     applicationCode: 'fe215caa-efeb-4646-836a-92cd3904f3d7',
  //     title: '编辑微信支付代金券'
  //   }
  // }
]

export default couponRoutes
